define('helper-entity-isParentQuizTaskPage',['exports', './content--get-entity.es', './entity--is-quiz-page.es'], function (exports, _contentGetEntity, _entityIsQuizPage) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _contentGetEntity2 = _interopRequireDefault(_contentGetEntity);

    var _entityIsQuizPage2 = _interopRequireDefault(_entityIsQuizPage);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var f = function f(parentID, contentEntities) {
        var entity;

        if (!parentID || typeof parentID !== 'string') {
            return false;
        }

        entity = (0, _contentGetEntity2.default)(parentID, contentEntities);

        if (!entity) {
            return false;
        }

        return (0, _entityIsQuizPage2.default)(entity) ? true : f(entity.contentEntity.parentId, contentEntities);
    };

    exports.default = function (parentID, contentEntities) {
        return f(parentID, contentEntities);
    };
});
